import { createBrowserHistory as createHistory } from "history"
import { createStore, applyMiddleware, compose, combineReducers } from "redux"
import { routerMiddleware } from "react-router-redux"
import persistState from "redux-localstorage"
import thunk from "redux-thunk"
import request from "superagent"
import prefix from "superagent-prefix"
import jwtDecode from "jwt-decode"
import moment from "moment"
import { camelCase } from "lodash"

// REDUCERS
import { routerReducer } from "react-router-redux"
import { messagingProps } from "../reducers/message-drawer"
let reducers = {}
let defaults = {}
const reducersReq = require.context("../reducers", true, /^(.*\.(js$))[^.]*$/im)
reducersReq.keys().forEach(key => {
  const reducerName = camelCase(key.match(/.\/([\w-]+).js/)[1])
  reducers[reducerName] = reducersReq(key).default
  defaults[reducerName] = reducersReq(key)[`${reducerName}ReducerDefaultState`]
})

// const OLDURL = "http://192.168.5.24:3336"

const OLDURL =
  process.env.REACT_APP_ENV === "production"
    ? "https://api.crewmama.com"
    : process.env.REACT_APP_ENV === "staging"
      ? "https://stagingapi.crewmama.com"
      : // "https://api.crewmama.com"
        // "https://stagingapi.crewmama.com"
        "http://localhost:3336"

export const API = request.agent().use(prefix(OLDURL))
export const AUTH = request.agent().use(prefix(OLDURL))

export const history = createHistory()

const initialState = {}
const enhancers = []
const middleware = [thunk, routerMiddleware(history)]

enhancers.push(
  persistState(null, {
    key: "ADESK",
    slicer: paths => {
      return state => {
        let isSuperAdmin = defaults.authentication.isSuperAdmin
        if (state.authentication.token) {
          const decodedToken = jwtDecode(state.authentication.token)
          if (decodedToken.companies === "*") {
            isSuperAdmin = true
          }
        }
        return {
          authentication: {
            ...defaults.authentication,
            authenticatedUser: state.authentication.authenticatedUser,
            token: state.authentication.token,
            isSuperAdmin,
          },
          messageDrawer: {
            ...defaults.messageDrawer,
            activeChatter: state.messageDrawer.activeChatter,
            activeChats: state.messageDrawer.activeChats.map(c => ({
              ...c,
              ...messagingProps,
              readMessages: c.readMessages,
            })),
          },
          companies: {
            ...defaults.companies,
            activeCompany: state.companies.activeCompany,
            accessLevel: state.companies.accessLevel,
          },
        }
      }
    },
    merge: (initialState, persistedState) => {
      if (persistedState.authentication.token) {
        // decode the token
        const decodedToken = jwtDecode(persistedState.authentication.token)
        // get the expiration as a moment
        const expDate = moment.unix(decodedToken.exp)
        // get today as a moment
        const nowDate = moment()
        // get the difference in hours
        const differenceInHours = nowDate.diff(expDate, "hours", true)
        // if the difference is greater than an hour throw our the loaded state to force a login
        if (differenceInHours > 1) {
          persistedState = {}
        } else {
          // otherwise allow the loaded state to be hydrated
          API.set("Authorization", persistedState.authentication.token)
          AUTH.set("Authorization", persistedState.authentication.token)
        }
      }
      if (persistedState.companies.activeCompany) {
        API.use(req =>
          req.query({
            company_id: persistedState.companies.activeCompany,
          })
        )
      }
      return persistedState
        ? { ...initialState, ...persistedState }
        : initialState
    },
  })
)

if (process.env.NODE_ENV === "development") {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
)

const store = createStore(
  combineReducers({
    routing: routerReducer,
    ...reducers,
  }),
  initialState,
  composedEnhancers
)

export default store
